export interface Theme {
  name: string;
  properties: any;
}

export const light: Theme = {
  name: "light",
  properties: {
    "--js-red": "#d6202a",
    "--js-green": "#2d9c48",
    "--js-dark-green": "#1d652e",
    "--js-dark-red": "#d1212a",

    "--tallite-heading-background": hexToRGB("#4285f4"),
    "--tallite-heading-font": "#000000",

    "--tallite-header-background": hexToRGB("#ffffff"),
    "--tallite-header-hover-background": hexToRGB("#ffffff"),
    "--tallite-header-font": "#000000",
    "--tallite-header-active-font": "#ff7112",
    "--tallite-header-opacity": "1",
    "--tallite-header-hover-opacity": "1",

    "--tallite-primary": "#1172b7",
    "--tallite-primary-hover": "#386097",
    "--tallite-primary-font": "#ffffff",
    "--tallite-orange": "#ff7112",
    "--tallite-orange-hover": "#ff7112",
    "--tallite-orange-font": "#ff7112",
    "--tallite-secondary": "#f5f5f5",
    "--tallite-secondary-hover": "#f5f5f5",
    "--tallite-secondary-font": "#000000",

    "--tallite-green": "#06c288",
  }
};

export const dark: Theme = {
  name: "dark",
  properties: {
    "--js-red": "#d6202a",
    "--js-green": "#2d9c48",
    "--js-dark-green": "#1d652e",
    "--js-dark-red": "#d1212a",

    "--tallite-heading-background": "#4285f4",
    "--tallite-heading-font": "#000000",

    "--tallite-header-background": "#848948",
    "--tallite-header-hover-background": "#ffffff",
    "--tallite-header-font": "#000000",
    "--tallite-header-active-font": "#ff7112",
    "--tallite-header-opacity": .6,
    "--tallite-header-hover-opacity": 1,

    "--tallite-primary": "#1172b7",
    "--tallite-primary-hover": "#386097",
    "--tallite-primary-font": "#ffffff",
    "--tallite-orange": "#ff7112",
    "--tallite-orange-hover": "#ff7112",
    "--tallite-orange-font": "#ff7112",
    "--tallite-secondary": "#f5f5f5",
    "--tallite-secondary-hover": "#f5f5f5",
    "--tallite-secondary-font": "#000000",

    "--tallite-green": "#06c288",
  }
};

export function hexToRGB(h) {
  let r: any = 0, g: any = 0, b: any = 0;

  // 3 digits
  if (h.length == 4) {
    r = "0x" + h[1] + h[1];
    g = "0x" + h[2] + h[2];
    b = "0x" + h[3] + h[3];

    // 6 digits
  } else if (h.length == 7) {
    r = "0x" + h[1] + h[2];
    g = "0x" + h[3] + h[4];
    b = "0x" + h[5] + h[6];
  }
  console.log("(" + +r + "," + +g + "," + +b + ")")
  return + +r + "," + +g + "," + +b;
}